import { Component} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ErrorMessage, ErrorType } from 'src/app/shared/entity/error.const';
import { DataAccessService } from 'src/app/shared/services/data-access/data-access.service';
import { DataRepositoryService } from 'src/app/shared/services/data-repository/data-repository.service';
import { UserColumnPreferencesService } from '../setting/column-preference/user-column-preferences-service/user-column-preferences.service';
import { ColumnService } from 'src/app/shared/services/column-services/column.service';
import { ConnectionStatus } from 'src/app/shared/entity/enums';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent {

  hideAppOptions: boolean = true;
  isOffline: boolean = false;
  offlineStatusMessage = ErrorMessage.OFFLINESTATUS;
  constructor(
    private readonly dataAccessService : DataAccessService,
    private readonly messageService :MessageService,
    private readonly dataRepositoryService: DataRepositoryService,
    private readonly userColumnPreferenceService: UserColumnPreferencesService,
    private readonly columnService: ColumnService
  ) { }


  appOptionsStatus(status: boolean) {
    this.hideAppOptions = status;
  }
  ngOnInit(){
    this.dataAccessService.isSelectedRouteEmpty$.subscribe((isRouteEmpty :boolean) =>{
        if(isRouteEmpty){
        this.messageService.add({
          severity:ErrorType.WARNING,
          summary : "",
          detail:ErrorMessage.NOTASKONROUTE,
        })
      }

    })
    if (!this.dataRepositoryService.userColumnPreferencesList().length) {
      this.userColumnPreferenceService.getUserColumnPreference();
    }
    if(this.dataRepositoryService.selectedUserColumnPreferences() === null) {
      this.columnService.getSelectedUserColumnPreference();
    }

    this.dataAccessService.connectionSubscription$.subscribe(
      (connectionStatus: string) => {
        if (connectionStatus.toLowerCase() === ConnectionStatus.Offline) {
          this.isOffline = true;
        }
        if (connectionStatus.toLowerCase() === ConnectionStatus.Online) {
          this.isOffline = false;
        }
      }
    );
  }

}
